import { render, staticRenderFns } from "./TyreAnalysis.vue?vue&type=template&id=4a963326"
import script from "./TyreAnalysis.vue?vue&type=script&lang=js"
export * from "./TyreAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports